export const dataHooks = {
  mobileHeader: 'mobile-preview-widget-header',
  mobileContent: 'mobile-preview-widget-content',
  mobileFooter: 'mobile-preview-widget-footer',
};

export const skins = {
  neutral: 'neutral',
  gradient: 'gradient',
  custom: 'custom',
};
